import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Prestations from "./pages/Prestations";
import FormationsInternes from "./pages/FormationsInternes";
import PrestationDetail from "./pages/PrestationDetail";
import FormationInterneDetail from "./pages/FormationInterneDetail";
import Calendrier from "./pages/Calendrier";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/prestations" element={<Prestations />} />
          <Route path="/prestations/:slug" element={<PrestationDetail />} />
          <Route path="/formations" element={<FormationsInternes />} />
          <Route path="/formations/:slug" element={<FormationInterneDetail />} />
          <Route path="/calendrier" element={<Calendrier />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
